import React from 'react'
import {Link} from 'react-router-dom';
import d8 from './MenuContent.module.css'
import { BsQuestionCircle } from 'react-icons/bs';
import {IoNotificationsOutline ,IoCloudDoneOutline,IoPricetagsOutline} from 'react-icons/io5'
import {AiOutlineFileDone ,AiOutlineTeam} from 'react-icons/ai'
import {MdOutlinePayments} from 'react-icons/md'
import {FiPhone} from 'react-icons/fi'
import {HiOutlineHome, HiOutlineStatusOnline} from 'react-icons/hi'
function MenuContent(props) {
    return (
        <div className={d8.container}>
        <ul >
        <li onClick={props.onClick}><Link to='/'><HiOutlineHome/>Home</Link></li>
         <li onClick={props.onClick}><Link to="/ask"><BsQuestionCircle/>Ask a question</Link></li>
         <li onClick={props.onClick}><Link to='/answered'><AiOutlineFileDone/>Answered</Link></li>
         <li><hr/></li>
         <li onClick={props.onClick}><Link to='/notification'><IoNotificationsOutline/>News</Link></li>
         <li onClick={props.onClick}><Link to='/webinars'><HiOutlineStatusOnline/>Webinars</Link></li>
         {/* <li onClick={props.onClick}><Link to='/summaries'><IoCloudDoneOutline/>Subject summaries</Link></li> */}
         <li onClick={props.onClick}><Link to='/payments'><MdOutlinePayments/>My payments</Link></li>
         <li><hr/></li>
        
         
         <li onClick={props.onClick}><Link to='/pricing'><IoPricetagsOutline/>Pricing</Link></li>
         <li onClick={props.onClick}><Link to='/contact_us'><FiPhone/>Contact us</Link></li> 
         <li onClick={props.onClick}><Link to='/join-the-team'><AiOutlineTeam/>Join our Team</Link></li>   

        </ul>    
        </div>
    )
}

export default MenuContent
